import { QueryAccountResponse } from "../types";

export const DebitCardConstants = {
  ATM_WITHDRAWAL_DAILY_LIMIT: "$500 Daily",
  CARD_SPEND_DAILY_LIMIT: "$2,500 Daily",
};

export const hasDebitCard = (
  data: QueryAccountResponse["challenger_saving"]["debit_card"]
) => {
  return data.latest_card_id !== null;
};

export const cardIsActivated = (
  data: QueryAccountResponse["challenger_saving"]["debit_card"]
) => {
  if (!hasDebitCard(data)) return false;
  if (data.latest_card_unactivated) return false;
  return true;
};

export const showDebitCardFeature = (
  data?: QueryAccountResponse["challenger_saving"]["debit_card"]
) => {
  if (!data) return false;
  // if the program offers debit cards, show the feature
  if (data.program_offer_debit_cards_enabled) return true;
  // if the user has a debit card, show the feature (even if the program doesn't offer them - the user could have gotten a card before the program stopped offering them)
  if (hasDebitCard(data)) return true;

  return false;
};
